const sm2 = require("sm-crypto").sm2;
let pk = '042B927AA7D977B87FB0491CCF4BB14966B443B32CDC8AF1F72E4E21C256E36846B35B8A3DDFCDC6ECCF86DF9728E5D1B6E8340BE4AF7167634E07850E898797E5'
let prik = '009B23E6AD2E020563EF328232ECB505EDD18CD2E58CDF8851BC4AF034A687F12C'
// sm2加密
function sm2doEncrypt(data) {
    const cipherMode = 0; // 1 - C1C3C2，0 - C1C2C3，默认为1
    let jmContent = "04" + sm2.doEncrypt(data, pk, cipherMode); // 加密结果
    console.log("加密", jmContent);
    return jmContent

}
// sm2解密
function sm2doDecrypt(content) {
    var doDecrypt = sm2.doDecrypt(content.slice(2), prik, 0);
    return doDecrypt
}
// 姓名脱敏
function desensitizeChineseName(name) {
    if (!name) {
        return "";
    }
    if (name.length <= 1) {
        return name;
    }
    const firstChar = name.charAt(0);
    const starCount = name.length - 1;
    const stars = "*".repeat(starCount);
    return firstChar + stars;
}
// 身份证号脱敏
function desensitizeIDNumber(idNumber) {
    if (!idNumber) {
        return "";
    }
    if (idNumber.length < 4) {
        return idNumber;
    }
    const lastFourDigits = idNumber.slice(-4);
    const stars = "*".repeat(idNumber.length - 4);
    return stars + lastFourDigits;
}
// 导出内容
export default {
    sm2doDecrypt,
    sm2doEncrypt,
    desensitizeChineseName,
    desensitizeIDNumber
}